var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityBubbleImage } from '@shapeable/ui';
var cls = classNames('entity-map-marker');
export var EntityMapMarkerDefaultProps = {
  size: 40
};
// -------- Styles -------->
var BubbleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n    border: 1px solid ", ";\n    border-radius: 100%;\n    background: ", ";\n    ", ";\n  "], ["\n    cursor: pointer;\n    border: 1px solid ", ";\n    border-radius: 100%;\n    background: ", ";\n    ", ";\n  "])), theme.COLOR('light'), theme.COLOR('canvas'), function (props) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: ", "px;\n    "], ["\n      border-radius: ", "px;\n    "])), props.size);
  })
});
// -------- Components -------->
var My = {
  Bubble: styled(EntityBubbleImage)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), BubbleStyles)
};
export var EntityMapMarker = function (props) {
  var className = props.className,
    entity = props.entity,
    imageStyle = props.imageStyle,
    size = props.size;
  // console.log(imageStyle)
  return React.createElement(My.Bubble, {
    className: cls.name(className),
    imageStyle: imageStyle,
    size: size,
    entity: entity
  });
};
EntityMapMarker.defaultProps = EntityMapMarkerDefaultProps;
EntityMapMarker.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;